/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Right_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Center Right" |
*
* @param {Position_Center_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_right_title = /** @type {((inputs?: Position_Center_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : Au Centre a Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Mitte rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: Centro destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Правый центральный полузащитник")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Centro derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：中右")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ポジション: 中央右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: केंद्र दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro-Direita")
	return /** @type {LocalizedString} */ ("Position: Center Right")
});